<template>
    <div v-loading="isBusy">

        <h2 style="margin-top:20px">Snippets</h2>

        <el-tabs v-model="activeTab" type="border-card">
            <el-tab-pane v-for="tab in tabs" :name="tab.id" :key="`snippet-tab-${employer_id}-${tab.id}`">
                <span slot="label" v-if="formData[tab.id]">
                    {{ tab.name }}
                    <span v-if="unsaved[tab.id]" class="text-danger">(unsaved)</span>
                    <span class="label label-primary"
                          :title="`How many ${tab.id === 'employer' ? 'active' : tab.name} jobs exist on employer`"
                          style="margin-left:2px;">{{ formData[tab.id].active_jobs_count }}</span>
                    <span class="label label-default"
                          :title="`How many snippets are filled in ${tab.name} category`"
                          style="margin-left:2px;">{{ formData[tab.id].non_empty_count }}</span>
                </span>
                <SnippetDetail v-if="formData[tab.id]"
                               :tab_data="tab"
                               :key="`snippet-${employer_id}-${tab.id}`"
                               :snippets="snippets"
                               :employer_id="employer_id"
                               v-model="formData[tab.id]"
                               @changed="(event) => tabChanged(event)"
                               @save="saveAll"></SnippetDetail>
            </el-tab-pane>
        </el-tabs>

        <employer-notes-wrapper :employer-id="employer_id" />
    </div>
</template>

<script>
import SnippetDetail from './snippet-detail';

export default {
    components: { SnippetDetail },
    props: [
        'employer_id',
        'tabs',
        'snippets',
        'default_tab',
    ],
    data() {
        const unsaved = {};
        this.tabs.forEach(tab => {
            unsaved[tab.id] = false;
        });

        return {
            isBusy: false,
            activeTab: this.default_tab,
            unsaved: unsaved,
            formData: {},
        };
    },
    mounted() {
        this.refreshPage();
    },
    methods: {
        tabChanged(event) {
            this.unsaved[event.tab] = true;
            this.$set(this.formData, event.tab, event.values);
        },
        tabsReset() {
            this.tabs.forEach(tab => {
                this.unsaved[tab.id] = false;
            });
        },
        saveAll() {
            this.isBusy = true;
            return axios.post(url(`admin/employer/${this.employer_id}/save-snippet`), { snippets: this.formData})
                        .then(response => {
                            return this.refreshPage();
                        });
        },
        refreshPage() {
            this.isBusy = true;
            return axios.get(url(`admin/employer/${this.employer_id}/load-snippet-data`))
                        .then(response => {
                            this.formData = response.data.snippets;
                            this.tabsReset();
                            this.isBusy = false;
                        });
        },
    },
};
</script>
